import { useEffect, useState } from 'react'

export default function useTrophyLogic(trophyRef) {
    const [scrollY, setScrollY] = useState(window.scrollY)
    const [lastScrollY, setLastScrollY] = useState(window.scrollY)

    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY)
        }

        let frameId
        const rotateAndUpdate = () => {
            if (trophyRef.current) {
                const deltaScroll = scrollY - lastScrollY
                const accelerationMultiplier = 1.5
                const scrollVelocity = deltaScroll * accelerationMultiplier

                const baseSpinSpeed = 0.003
                const scrollSpinSpeed = Math.abs(scrollVelocity) * 0.002
                const totalSpinSpeed = baseSpinSpeed + scrollSpinSpeed

                trophyRef.current.rotation.y += totalSpinSpeed
            }
            frameId = requestAnimationFrame(rotateAndUpdate)
        }

        rotateAndUpdate()
        window.addEventListener('scroll', handleScroll)

        return () => {
            cancelAnimationFrame(frameId)
            window.removeEventListener('scroll', handleScroll)
        }
    }, [scrollY, lastScrollY, trophyRef])

    useEffect(() => {
        setLastScrollY(scrollY)
    }, [scrollY])
}
